import {ImSpinner9} from "react-icons/im"

const Loading=({message='Cargando...',height='90vh'})=>{
    return <div className={`flex flex-col w-full h-[${height}] my-6 items-center justify-center`}>
            <ImSpinner9 className='animate-spin mr-[2px]'/><h1 className="text-2xl">{message}</h1>
        </div>
}

export default Loading